<div class="access-shell">
  <main class="access-shell__content">
    <router-outlet />
  </main>
</div>
